import { PropsWithChildren, ReactNode } from 'react';
import MobileSidebarBtn from '../../components/Sidebar/MobileToggleBtn';
import { useSidebar } from '../../components/Sidebar/SidebarContext';
import * as s from './ContentContainerStyles';
import ContentLoad from './ContentLoad';

interface ContentContainerProps {
  title?: string;
  isLoading?: boolean;
  actions?: JSX.Element[];
  titleAddon?: ReactNode;
  type?: 'window' | 'fullscreen';
}

const ContentContainer: React.FC<PropsWithChildren<ContentContainerProps>> = ({
  title = '',
  isLoading = false,
  actions = [],
  titleAddon = null,
  children,
  type = 'fullscreen',
}) => {
  const { toggleSidebar } = useSidebar();

  return (
    <s.Container type={type}>
      <s.HeaderBar>
        <div className="content-container-title" onClick={() => toggleSidebar()}>
          <MobileSidebarBtn />
          <span className="content-container-title-label">{title}</span>
          {titleAddon ? (
            <span
              className="content-container-title-addon"
              onClick={(event) => event.stopPropagation()}
              role="presentation"
            >
              {titleAddon}
            </span>
          ) : null}
        </div>
        <ul className="content-container-actions-area">
          {actions.map((action, index) => {
            return <li key={index}>{action}</li>;
          })}
        </ul>
      </s.HeaderBar>
      {isLoading ? <ContentLoad /> : <s.Content>{children}</s.Content>}
    </s.Container>
  );
};

ContentContainer.defaultProps = {
  title: '',
  titleAddon: null,
};

export default ContentContainer;
